export default "__VITE_ASSET__DW4chdGt__"